// extracted by mini-css-extract-plugin
module.exports = {"detailList":"detailList--cf8KG","system":"system--SH5V7","taskItem":"taskItem--pZYBj","logsIcon":"logsIcon--CktL_","failTxt":"failTxt--iGGrG","failLogTxt":"failLogTxt--poXbF"};